import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import {
  Dimmer,
  Form,
  Loader,
  Table,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import qs from 'qs';
import { required } from '@mhub/web-validations';
import { flashErrorMessage } from '../actions/flash';
import { fetchM } from '../actions/fetchM';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import AppForm from './AppForm';

class AddressSettingList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    loading: PropTypes.bool,
    onOriChange: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      loading: props.loading || true,
      data: [],
      errMessages: [],
    };
    this.validation = {};
  }
  componentDidMount() {
    this.fetchAddressSettings();
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async validate() {
    const { data } = this.state;
    const stateData = data.reduce((d, cur) => ({
      ...d,
      [`${cur.columnName}_label`]: cur.label,
      [`${cur.columnName}_required`]: cur.required,
      [`${cur.columnName}_enabled`]: cur.enabled,
    }), {});
    return AppForm.validate(this.validation, stateData)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        return validations;
      });
  }
  async fetchAddressSettings() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = {
      page: 'all',
    };
    let res;
    try {
      res = await store.dispatch(fetchM(`/address_settings/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      await this.setComponentState({
        count,
        token,
        data: data || [],
      });
      this.props.onOriChange(data);
    }
    await this.setLoading(false);
  }
  handleLabelChange = (event, { name, value }) => {
    const { data } = this.state;
    const index = data.findIndex(d => d.columnName === name);
    if (index >= 0) {
      data[index].label = value;
    }
    this.setState({ data }, () => {
      this.props.onChange(data);
    });
  }
  handleRequiredChange = (event, { name }) => {
    const { data } = this.state;
    const index = data.findIndex(f => f.columnName === name);
    if (index >= 0) {
      data[index].required = !data[index].required;
    }
    this.setState({ data }, () => {
      this.props.onChange(data);
    });
  }
  handleEnabledChange = (event, { name }) => {
    const { data } = this.state;
    const index = data.findIndex(f => f.columnName === name);
    if (index >= 0) {
      data[index].enabled = !data[index].enabled;
    }
    this.setState({ data }, () => {
      this.props.onChange(data);
    });
  }
  render() {
    const { t } = this.props;
    return (
      <div>
        <Dimmer
          inverted style={{ zIndex: 20 }}
          active={this.state.loading && this.state.data.length > 0}
        >
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        <Table
          striped unstackable
          selectable
        >
          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell width={4}>{t('Field')}</Table.HeaderCell>
              <Table.HeaderCell width={4}>{t('Label')}</Table.HeaderCell>
              <Table.HeaderCell width={3} textAlign="right">{t('Required')}</Table.HeaderCell>
              <Table.HeaderCell width={3} textAlign="right">{t('Enabled')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              this.state.data.length > 0 ?
              this.state.data.map((field, key) => {
                let columnName = _.startCase(field.columnName);
                columnName = columnName.split(' ');
                columnName = t(columnName[0]).concat(' ', columnName[1]);
                // add validateRef
                this.validation[`${field.columnName}_label`] = createRef();
                return (
                  <Table.Row key={key}>
                    <Table.Cell width={4}>
                      {columnName}
                    </Table.Cell>
                    <Table.Cell width={4}>
                      <AppForm.Input
                        validateLabel={t('{{columnName}}\'s Label', { columnName: columnName })}
                        name={field.columnName}
                        value={field.label}
                        validation={[required]}
                        onChange={this.handleLabelChange}
                        ref={this.validation[`${field.columnName}_label`]}
                      />
                    </Table.Cell>
                    <Table.Cell textAlign="right">
                      <Form.Checkbox
                        toggle
                        checked={field.required}
                        name={field.columnName}
                        onChange={this.handleRequiredChange}
                      />
                    </Table.Cell>
                    <Table.Cell textAlign="right">
                      <Form.Checkbox
                        toggle
                        checked={field.enabled}
                        name={field.columnName}
                        onChange={this.handleEnabledChange}
                      />
                    </Table.Cell>
                  </Table.Row>
                );
              }) : (
                <Table.Row>
                  <Table.Cell colSpan={4} textAlign="center">
                    {
                      this.state.loading ?
                      <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                      : <p>{t('No address fields found')}.</p>
                    }
                  </Table.Cell>
                </Table.Row>
              )
            }
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(AddressSettingList);



// WEBPACK FOOTER //
// ./src/components/AddressSettingList.jsx